import {
  REQUEST_COUPONS, RECEIVE_COUPONS, REQUEST_COUPON, RECEIVE_COUPON, RESET_ALL_COUPON, RESET_COUPON, REQUEST_SAVE_COUPON,
  RECEIVE_SAVE_COUPON, REQUEST_REMOVE_COUPON, RECEIVE_REMOVE_COUPON, REQUEST_APPLY_COUPON, RECEIVE_APPLY_COUPON,
  REQUEST_COUPON_SUMMARY, RECEIVE_COUPON_SUMMARY, REQUEST_COUPON_USAGES, RECEIVE_COUPON_USAGES, RESET_COUPON_DETAIL_EXTRA,
} from '../constants/ActionTypes'

const INITIAL_STATE = {
  list: {
    isLoading: false,
    data: {
      rows: [],
      count: 0,
      page: 1,
      limit: 50,
    },
    receivedAt: null,
  },
  item: {
    data: {},
    isLoading: false,
    receivedAt: null,
  },
  itemSave: {
    isLoading: false,
  },
  itemRemove: {
    isLoading: false,
  },
  apply: {
    isLoading: false,
    data: {},
  },
  summary: {
    isLoading: false,
    data: {
      total_desconto_concedido: 0,
      cashback_total: 0,
      cashback_a_liberar: 0,
    },
    receivedAt: null,
  },
  usages: {
    isLoading: false,
    data: {
      rows: [],
      count: 0,
      page: 1,
      limit: 20,
    },
    receivedAt: null,
  },
}

export default function CouponReducer(state = INITIAL_STATE, action) {
  switch(action.type) {
    case REQUEST_COUPONS:
      return {
        ...state,
        list: {
          isLoading: action.isLoading,
          data: INITIAL_STATE.list.data,
        }
      }
    case RECEIVE_COUPONS:
      return {
        ...state,
        list: {
          isLoading: action.isLoading,
          data: action.data,
          receivedAt: action.receivedAt,
        }
      }
    case REQUEST_COUPON:
      return {
        ...state,
        item: {
          isLoading: action.isLoading,
          data: INITIAL_STATE.item.data,
        }
      }
    case RECEIVE_COUPON:
      return {
        ...state,
        item: {
          isLoading: action.isLoading,
          data: action.data,
          receivedAt: action.receivedAt,
        }
      }
    case RESET_COUPON:
      return {
        ...state,
        item: INITIAL_STATE.item,
        summary: INITIAL_STATE.summary,
        usages: INITIAL_STATE.usages,
      }
    case RESET_COUPON_DETAIL_EXTRA:
      return {
        ...state,
        summary: INITIAL_STATE.summary,
        usages: INITIAL_STATE.usages,
      }
    case REQUEST_COUPON_SUMMARY:
      return {
        ...state,
        summary: {
          isLoading: action.isLoading,
          data: INITIAL_STATE.summary.data,
          receivedAt: null,
        },
      }
    case RECEIVE_COUPON_SUMMARY:
      return {
        ...state,
        summary: {
          isLoading: action.isLoading,
          data: action.data || INITIAL_STATE.summary.data,
          receivedAt: action.receivedAt,
        },
      }
    case REQUEST_COUPON_USAGES:
      return {
        ...state,
        usages: {
          isLoading: action.isLoading,
          data: INITIAL_STATE.usages.data,
          receivedAt: null,
        },
      }
    case RECEIVE_COUPON_USAGES:
      return {
        ...state,
        usages: {
          isLoading: action.isLoading,
          data: action.data || INITIAL_STATE.usages.data,
          receivedAt: action.receivedAt,
        },
      }
    case REQUEST_SAVE_COUPON:
    case RECEIVE_SAVE_COUPON:
      return {
        ...state,
        itemSave: {
          isLoading: action.isLoading,
        }
      }
    case REQUEST_REMOVE_COUPON:
    case RECEIVE_REMOVE_COUPON:
      return {
        ...state,
        itemRemove: {
          isLoading: action.isLoading,
        }
      }
    case REQUEST_APPLY_COUPON:
    case RECEIVE_APPLY_COUPON:
      return {
        ...state,
        apply: {
          isLoading: action.isLoading,
          data: action.data ? action.data : INITIAL_STATE.apply.data,
        }
      }
    case RESET_ALL_COUPON:
      return INITIAL_STATE
    default:
      return state
  }
}
